/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeZuordnungVorschauDto } from '../../models/lexplus-aufgabe-zuordnung-vorschau-dto';
import { LexplusUpdateAufgabeZuordnungDto } from '../../models/lexplus-update-aufgabe-zuordnung-dto';

export interface AufgabenControllerPreviewZuordnungV1$Params {
      body: LexplusUpdateAufgabeZuordnungDto
}

export function aufgabenControllerPreviewZuordnungV1(http: HttpClient, rootUrl: string, params: AufgabenControllerPreviewZuordnungV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeZuordnungVorschauDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerPreviewZuordnungV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeZuordnungVorschauDto>;
    })
  );
}

aufgabenControllerPreviewZuordnungV1.PATH = '/v1/aufgaben/zuordnung-vorschau';
